module.exports = __webpack_public_path__ + "static/assets/3930624f8e9e6951e54193383f5c4aaa.gif";